import axios from "axios";
import { serverApi } from "../../../config/Keys";
import {
  CLEAR_ERRORS,
  CLEAR_LOADER,
  SET_LOADER,
  ADMIN_SHORT_VIDEOS_GET,
  ADMIN_SHORT_VIDEOS_UPDATE_STATUS,
  ADMIN_SHORT_VIDEOS_DELETE,
} from "../../types";
import { setErrors } from "../errorActions";
import Alert from "react-s-alert";

export const short_videos_add =
  (token, formData, onSuccess) => async (dispatch) => {
    console.log(token, formData);
    try {
      dispatch({ type: CLEAR_ERRORS });
      let response = await axios.post(`${serverApi}/reels`, formData, {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 201) {
        Alert.success(`<h4> Updated succesfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 5000,
          offset: 35,
        });
        onSuccess();
      }
    } catch (err) {
      Alert.error(`<h4>${err.response.data.message}</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

  export const short_videos_edit =
  (token, formData, onSuccess) => async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      let response = await axios.patch(`${serverApi}/reels/${formData?.id}`, formData, {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        Alert.success(`<h4> Updated succesfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 5000,
          offset: 35,
        });
        onSuccess();
      }
    } catch (err) {
      Alert.error(`<h4>${err.response.data.message}</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const short_videos_get =
  (token, dateQuery, filters) => async (dispatch) => {
    try {
      dispatch({ type: SET_LOADER });
      dispatch({ type: CLEAR_ERRORS });
      let response = await axios.get(
        `${serverApi}/admin/reels?page=${
          filters?.page || 1
        }&limit=10&startDate=${dateQuery.startDate}&endDate=${
          dateQuery.endDate
        }&sortOrder=${filters.sortOrder}&sort=${filters.sortBy}&archive=${
          filters?.archive || false
        }&statusFilter=${filters.statusBy}&callToAction=${
          filters.callToAction
        }&search=${filters.search}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (response.status === 200) {
        //  onSuccess(response.data);
        dispatch({ type: ADMIN_SHORT_VIDEOS_GET, payload: response.data });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      console.log(err, "error");
      Alert.error(
        `<h4>${err?.response?.data || "Please Provide correct details."}</h4>`,
        {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 5000,
          offset: 35,
        }
      );
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const short_videos_status_update =
  (token, id, changed_status) => async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      let response = await axios.patch(
        `${serverApi}/reels/${id}?type=STATUS`,
        changed_status,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (response.status === 200) {
        Alert.success(`<h4> Updated succesfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 5000,
          offset: 35,
        });
        dispatch({
          type: ADMIN_SHORT_VIDEOS_UPDATE_STATUS,
          payload: response.data,
        });
        dispatch({ type: CLEAR_LOADER });
        return response;
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      return err;
    }
  };

export const short_videos_delete_request =
  (refId, token, onsuccess, onerror) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let del_req = await axios.delete(`${serverApi}/reels/${refId}`, {
        headers: {
          Authorization: token,
        },
      });
      if (del_req.status === 200) {
        onsuccess();
        Alert.success(`<h4> Updated Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: ADMIN_SHORT_VIDEOS_DELETE,
          payload: refId,
        });
      }
    } catch (err) {
      onerror();
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_liked_users_list = (id, page, limit) => async (dispatch) => {
  try {
    dispatch({ type: CLEAR_ERRORS });
    const data = await axios.get(
      `${serverApi}/admin/reels/${id}?likes=true&page=${page}&limit=${limit}`
    );
    return data.data;
  } catch (err) {
    console.error(err);
    dispatch(setErrors(err));
    return [];
  }
};

export const get_shared_users_list = (id, page, limit) => async (dispatch) => {
  try {
    dispatch({ type: CLEAR_ERRORS });
    const data = await axios.get(
      `${serverApi}/admin/reels/${id}?shares=true&page=${page}&limit=${limit}`
    );
    return data.data;
  } catch (err) {
    console.error(err);
    dispatch(setErrors(err));
    return [];
  }
};
